import React from 'react';

interface Holding {
  symbol: string;
  security_name: string;
  quantity?: number;
  market_value: number;
}

interface HoldingsTableProps {
  holdings: Holding[];
  formatCurrency: (amount: number) => string;
}

export const HoldingsTable: React.FC<HoldingsTableProps> = ({
  holdings,
  formatCurrency
}) => {
  if (!holdings || holdings.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No holdings available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">
              Symbol
            </th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground w-[40%]">
              Description
            </th>
            <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">
              Quantity
            </th>
            <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">
              Market Value
            </th>
          </tr>
        </thead>
        <tbody>
          {holdings.map((holding, index) => (
            <tr
              key={`${holding.symbol}-${index}`}
              className="border-b border-gray-100 hover:bg-gray-50"
            >
              <td className="py-3 px-4 text-sm font-medium">
                {holding.symbol}
              </td>
              <td className="py-3 px-4 text-sm text-muted-foreground">
                {holding.security_name}
              </td>
              <td className="py-3 px-4 text-sm text-right">
                {holding.quantity !== undefined
                  ? holding.quantity.toLocaleString()
                  : '-'}
              </td>
              <td className="py-3 px-4 text-sm text-right font-medium">
                {formatCurrency(holding.market_value)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
